import { AppInterface, AppType } from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/server/src/API/Apps/Apps.Controller.ts
export class AppsAPI {
  static async getApps(orgId: number) {
    return APIService.Server.get<AppInterface[]>(`/apps/org/${orgId}`);
  }
  static async getApp(orgId: number, appId: number) {
    return APIService.Server.get<AppInterface>(`/apps/org/${orgId}/app/${appId}`);
  }
  static async getAppInternal(appId: number) {
    return APIService.Server.get<AppInterface>(`/apps/app/${appId}`);
  }

  static async getAppByTypeForLocation(type: AppType, orgId: number, locationId?: number, returnDefault?: boolean) {
    let query = {};
    if (locationId) {
      query = { ...query, locationId };
    }
    if (returnDefault) {
      query = { ...query, returnDefault };
    }

    return APIService.Server.get<AppInterface>(`/apps/org/${orgId}/type/${type}/by-location`, query);
  }

  static async getTwilioOutboundAppByTypeForLocation(orgId: number, locationId?: number, returnDefault?: boolean): Promise<{ outboundApp: AppInterface, outboundApiKey: string, outboundApiSecret: string }> {
    let query = {};
    if (locationId) {
      query = { ...query, locationId };
    }
    if (returnDefault) {
      query = { ...query, returnDefault };
    }

    return APIService.Server.get<{ outboundApp: AppInterface, outboundApiKey: string, outboundApiSecret: string }>(`/apps/org/${orgId}/type/twilio/outbound`, query);
  }

  static async getAppsByType(orgId: number, type: AppType) {
    return APIService.Server.get<AppInterface[]>(`/apps/org/${orgId}/type/${type}`);
  }

  static async getAppByIdentifierAndType(identifier: string, type: AppType) {
    return APIService.Server.get<AppInterface>(`/apps/type/${type}/with-identifier`, {
      identifier,
    });
  }

  static async createApp(orgId: number, type: AppType) {
    return APIService.Server.post<AppInterface>(`/apps/org/${orgId}/type/${type}`);
  }
  static async updateApp(orgId: number, app: AppInterface) {
    return APIService.Server.put<AppInterface>(
      `/apps/org/${orgId}/app/${app.id}`,
      { app: app }, // Note we must wrap this otherwise it can sometimes override the token on server auth
    );
  }
  static async deleteApp(orgId: number, appId: number) {
    return APIService.Server.delete(`/apps/org/${orgId}/app/${appId}`);
  }
}
